import React from 'react';
import styles from './DrawerToggle.scss';

const drawerToggle = (props) => {
	return (
			<div className={styles.DrawerToggle} onClick={props.clicked}>
				<div></div>
				<div></div>
				<div></div>
			</div>
		);
}

export default drawerToggle;


// WEBPACK FOOTER //
// ./src/components/presentational/SideDrawer/DrawerToggle/DrawerToggle.js